uniform float uTime;

uniform sampler2D uPerlinTexture;
// uniform float uPortalOpening;
uniform vec3 uWaterColor;
uniform float uWaterOpacity;
// uniform float uRipples;
// uniform float uRippleSpeed;
// uniform float uPerlinBlend;
// uniform float uPerlinMultiply;

varying vec2 vUv;

void main()
{
    vec2 perlinUv = vUv;
    perlinUv.x += 0.02 * cos(uTime);
    perlinUv.y += 0.02 * sin(uTime);
    vec4 perlin = texture(uPerlinTexture, perlinUv);

    // vec2 perlinUv2 = vUv;
    // perlinUv2 *= -1.7;
    // perlinUv2.x += 0.05 * uTime;
    // perlinUv2.y += 0.05 * uTime;
    // vec4 perlin2 = texture(uPerlinTexture, perlinUv2);

    // perlin1 *= uPerlinBlend * perlin2;
    
    // float distanceFromCenter = distance(vUv, vec2(0.5));
    // float outerGlow = smoothstep(0.0, 1.0, distanceFromCenter) + (cos(uPortalOpening) + 0.59);
    // float strength = 1.0;


    // strength *= 2.0 + cos(uRipples * distanceFromCenter + (uRippleSpeed * uTime));
    // strength *= distance(perlin1, perlin2);

    // gl_FragColor = vec4(vec3(strength) * uPortalColor, outerGlow);
    gl_FragColor = vec4(uWaterColor, uWaterOpacity + (0.5 * perlin.x));

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}